import React from "react";


const OurStoryVideo = () => {


    return (
        <>
            <div className="our-story-video" >

                <div className="CTA-wrapper">
                    <iframe
                        className="our-story-video-embed"
                        width="560"
                        height="315"
                        src="https://www.youtube-nocookie.com/embed/4Hwz6ReNx_w"
                        title="YouTube short video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    ></iframe>
                    <iframe
                        className="our-story-video-embed"
                        width="560"
                        height="315"
                        src="https://www.youtube-nocookie.com/embed/4QE1zZm9AzU?si=C4U1scIa2pJfDKli"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>

        </>
    )
}

export default OurStoryVideo
